module.exports = __webpack_public_path__ + "static/media/loader.4e242a31.gif";